import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import ButtonSubmit from '../../components/ButtonSubmit'
import { ErrorMessage } from '../../components/ErrorMessage'
import { Input } from '../../components/Input'
import { SolicitaResetSenha } from '../../services/accountService'
import '../Login/Login.css'

function EsqueciSenha() {
  const navigate = useNavigate()

  const [userName, setUserName] = useState('')
  const [erro, setErro] = useState('')
  const [mensagemEnviada, setMensagemEnviada] = useState(false)

  async function solicitaReset(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    if (!userName) {
      setErro('Informe seu usuário ou e-mail')
      return
    }

    try {
      await SolicitaResetSenha(userName)
      setErro('')
      setMensagemEnviada(true)
    } catch {
      setErro('Não foi possível processar a solicitação. Tente novamente mais tarde.')
    }
  }

  return (
    <div className="login">
      <div className="headerLogin">
        <h4>MONITRAN - Sistema de Permissionários</h4>
      </div>

      <div className="loginUser">
        <h3>Esqueci minha senha</h3>

        {mensagemEnviada ? (
          <div className="formLogin col-11 mt-3">
            <p>Se o usuário existir, enviamos um e-mail com instruções para redefinir a senha.</p>
            <ButtonSubmit type="button" text="Voltar ao login" onClick={() => navigate('/')} />
          </div>
        ) : (
          <form onSubmit={solicitaReset} className="formLogin col-11 mt-3">
            <div className="labelLogin">
              <label htmlFor="userName" className="inputfield">
                Usuário ou e-mail
              </label>
              <Input id="userName" value={userName} onChange={(e) => setUserName(e.target.value)} />
            </div>

            <ErrorMessage text={erro} />

            <div className="col-12">
              <ButtonSubmit type="submit" text="Enviar" />
            </div>

            <div className="col-12 mt-2">
              <button type="button" className="linkEsqueciSenha" onClick={() => navigate('/')}>
                Voltar ao login
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default EsqueciSenha
